import type { DeepPartial } from '@luna/utils-ts';

import type { OwnTransfer } from './OwnTransfer';

export const RO: DeepPartial<OwnTransfer> = {
    isTermDepositToTermDepositTransferAllowed: false,
    isCollectiveSigningInfoDisplayed: true,
};
